import { GuestsDataContext } from 'components/common/MarchPromo/utils/guestsDataProvider'
import { RadioTileGroup } from 'components/shared/RadioTileGroup'
import { SimpleRadioTileGroupItem } from 'components/shared/RadioTileGroup/subcomponents/SimpleRadioTileGroupItem'
import {
    MARCH_PROMO_PROLONGED_VOUCHER_PRICE,
    MARCH_PROMO_STANDARD_VOUCHER_PRICE,
} from 'constants/prices'
import { useContext } from 'react'
import { useIntl } from 'react-intl'
import { useResolutions } from 'store/resolutions'

export const VoucherSelector = () => {
    const { formatMessage } = useIntl()
    const { isMobile } = useResolutions()
    const { setTotalPrice, marchVouchersData, voucherPrice, setVoucherPrice } =
        useContext(GuestsDataContext)

    const handleVoucherChange = (value: string) => {
        const totalPrice = marchVouchersData
            .map(({ tickets }) => tickets.length * Number(value))
            .reduce((acc, curr) => acc + curr, 0)
        setTotalPrice(totalPrice)
        setVoucherPrice(Number(value))
    }

    return (
        <RadioTileGroup
            value={String(voucherPrice)}
            isExpandable
            isAutoScrolling
            columns={isMobile ? 1 : 2}
            onChange={handleVoucherChange}
            data-testid="voucher-selector"
        >
            <SimpleRadioTileGroupItem
                id="voucher-1"
                value={String(MARCH_PROMO_STANDARD_VOUCHER_PRICE)}
                variant="big"
                width={'100%'}
                label={formatMessage({
                    id: 'promo.march.voucher_selector_label_1',
                    defaultMessage: 'do 30 kwietnia',
                })}
                price={MARCH_PROMO_STANDARD_VOUCHER_PRICE}
                priceLabel={formatMessage({
                    id: 'promo.march.per_person',
                    defaultMessage: 'za osobę',
                })}
            />
            <SimpleRadioTileGroupItem
                id="voucher-2"
                value={String(MARCH_PROMO_PROLONGED_VOUCHER_PRICE)}
                variant="big"
                width={'100%'}
                label={formatMessage({
                    id: 'promo.march.voucher_selector_label_2',
                    defaultMessage: 'do 31 maja',
                })}
                price={MARCH_PROMO_PROLONGED_VOUCHER_PRICE}
                priceLabel={formatMessage({
                    id: 'promo.march.per_person',
                    defaultMessage: 'za osobę',
                })}
            />
        </RadioTileGroup>
    )
}
